import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';

@Component({
	selector: 'cancel-subscription-confirm-modal',
	template: require('./cancel-subscription-confirm-modal.html'),
	styles: [require('./cancel-subscription-confirm-modal.scss')]
})
export class CancelSubscriptionConfirmModalComponent {
	@Input() btnDisable: boolean;

	feedback: string;

	constructor(
		private activeModal: NgbActiveModal,
		private modalService: SNModalService
	) {}

	cancelSubscription(): void {
		this.btnDisable = true;
		this.modalService.setModalData(this.feedback);
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.ts